<template>
  <div class="main-r-wrap">
    <div class="main-r-top">
      <span
        class="main-r_top_nav"
        :class="mainStatus === 'online' && 'active'"
        @click.stop="handleClick('online')"
      >{{ $lang('在线文档') }}</span>
      <!-- <span
        class="main-r_top_nav"
        :class="mainStatus === 'apiTest' && 'active'"
        @click.stop="handleClick('apiTest')"
      >测试工具</span> -->
    </div>
    <!-- 在线文档 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'online'">
      <online-doc :onlineData="onlineData"></online-doc>
    </div>
    <!-- 在线文档 END -->
    <!-- 测试工具 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'apiTest'">
      <api-test-doc :apiTestData="apiTestData"></api-test-doc>
    </div>
    <!-- 测试工具 END -->
  </div>
</template>

<script>
import onlineDoc from "../components/onlineDoc";

import apiTestDoc from "../components/apiTestDoc";


import {OPEN_API_TEST,OPEN_API_PRO} from '@/constants/index'
const apiUrlTest = 'trace/subscribe';
export default {
name:"subscribe",
  components: { onlineDoc , apiTestDoc },
  data() {
    const that = this
    return {    
      mainStatus: "online",
      //当前请求URL
      apiBaseUrl: process.env.VUE_APP_API_URL + `/${apiUrlTest}`,

      onlineData: {
        //接口描述
        apiDesc: `向极兔订阅需推送物流轨迹的运单号 <br/> <strong>注意事项：需提供回传物流轨迹的URL</strong> `,
        //接口地址
        testApi: `${OPEN_API_TEST}/${apiUrlTest}`,
        proApi: `${OPEN_API_PRO}/${apiUrlTest}`,
        //参数描述  START
       postDataList:[
            
        //   请求头参数
            {
                title:'Headers',
                value:[
                    {name: "apiAccount",type: "Number",require: "Y",normal: "",describe: "接入方可在控制台的应用内查看apiAccount",},
                    {name: "digest",type: "String",require: "Y",normal: "",describe: "签名字符串,请在签名工具内获取",},
                    {name: "timestamp",type: "Number",require: "Y",normal: "东八区（UTC+8）",describe: "时间戳，毫秒",},
                    ]
            },
             { 
                title:'请求参数', 
                 value:[
                    {name: "bizContent",type: "String",require: "Y",normal: "业务参数",describe: "业务参数模块内json格式的string类型",},
                ]
            },
             {
              title:"业务参数",
              value:[
                {name: "customerCode",type: "String(30)",require: "Y",normal: "J0086474299",describe: "客户编码（联系出货网点提供）"},
                {name: "password",type: "String(100)",require: "Y",normal: "",describe: "请在签名工具内获取接口的password"},
                {name: "list",type: "Object ",require: "Y",normal: "",describe: "订阅的数据"},
              ]
            },
         {
           title:"list参数",
           value:[
             {name: "traceNode",type: "string",require: "Y",normal: "10&20&30",describe: `<p>${ that.$lang('10：快件揽收') }</p><p>${ that.$lang('20：发件扫描') }</p><p>${ that.$lang('30：到件扫描') }</p>
                     <p>${ that.$lang('94：派件扫描') }</p><p>${ that.$lang('100：快件签收') }</p><p>${ that.$lang('110：问题件扫描') }</p><p>${ that.$lang('172：退件扫描 ') }</p><p>${ that.$lang('173：退件签收') }</p><p>${ that.$lang('200：寄件入库') }</p>`, isHtml: true},
             {name: "billCode",type: "String(30)",require: "Y",normal: "",describe: "运单号"},
           ]
         }
        ],
        //参数描述  END
        //报文描述 start
        responseDataList:[
            
        //   响应参数
            {
                title:'响应参数',
                value:[
                  { name: "code",type: "String(10)", require: "Y",normal: "",describe: "1为成功 其他为失败,此时关注msg中返回的失败原因"},
                  {name: "msg",type: "String(100)",require: "Y",normal: "success",describe: "返回信息"},
                  {name: "data",type: "Object",require: "Y",normal: "",describe: "业务数据"},
                  {name: "requestId",type: "String(30)",require: "Y",normal: "",describe: "唯一请求ID   有问题时，可以提供这个信息"},
                  ]
            }
        ],
        //请求示例
        requestCode: `
{
   "customerCode": "1232131",
    "password": "123123213",
  "list": [{
  "traceNode": "1&2&3&4&5&6&7&8&9&10&11",
  "billCode": "JT4000096429493"
  }，{
  "traceNode": "1&2&3&4&5&6&7&8&9&10&11",
  "billCode": "JT4000096429423"
  }，{
  "traceNode": "1&2&3&4&5&6&7&8&9&10&11",
  "billCode": "JT4000096429423"
  }]
}"`,
        //返回示例
        responseCode: {"code":"1","msg":"success",data:"SUCCESS","requestID":  "211212121212"} ,
      },


      apiTestData: {
          _headerData: {
            apiAccount: "1001",
            digest: "U40e5sumorgd3YgZzU61Mw==",
            timestamp: "1565238848921",
          },
          data:{
             bizContent: `{"id":"1001","list":[{"traceNode":"1&2&3&4&5&6&7&8&9&10&11","waybillCode":"JT4000096429493"}]}`,
          },
        //必须要验证的参数
        requestData:['apiAccount','digest','timestamp','bizContent'],
        textareaData:{
          bizContent:true
        },
        //促发接口
        apiUrl: `/mock/trace/subscribe`,
        //返回
        ResponseJson: "",
        //当前请求URL
        apiBaseUrl: process.env.VUE_APP_API_URL + `/mock/trace/subscribe`,
       //错误代码提示
        errcodeJson: [{code:'145013501',msg:"运单号个数超过1000"},
          {code:'145003100',msg:"运单号非法"}]
      },
    };
  },
  created() {},
  methods: {
    handleClick(status) {
      this.mainStatus = status;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/apiTest.scss";
</style>